import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinaundhpune() {



  const cardData = {
"keyword": "Tempo Traveller on Rent in Aundh Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller on Rent in Aundh, Pune for family trips, corporate travel, airport transfers, weddings, school tours, and outstation group journeys. Our fleet includes 9, 12, 14, 17, 20, and 26-seater Tempo Travellers with AC, pushback seats, spacious interiors, and experienced drivers familiar with Aundh, Baner, Wakad, and Pune city routes. We provide safe, comfortable, and punctual group travel with doorstep pickup from Aundh and nearby residential and commercial areas.",

"topPlaces": [

{
"title": "Harishchandragad",
"description":
"Harishchandragad is a legendary hill fort known for its extreme trekking routes, Konkan Kada cliff view, caves, and ancient temples. It attracts adventure seekers, camping groups, and trekking lovers from Pune looking for challenging weekend expeditions and sunrise viewpoints."
},
{
"title": "Sandhan Valley",
"description":
"Sandhan Valley is often called the Grand Canyon of Maharashtra, known for narrow rock passages, rappelling, camping, and adventure trekking. It is a top destination for extreme adventure groups, youth trips, and organized trekking tours from Pune."
},
{
"title": "Devkund Waterfall",
"description":
"Devkund Waterfall is a pristine hidden waterfall located deep inside forest trails, known for its turquoise water and trekking adventure route. It is one of the most popular monsoon trekking destinations for group travelers from Pune seeking natural beauty and forest exploration."
},
{
"title": "Kauncha Waterfall",
"description":
"Kauncha Waterfall is a hidden natural waterfall destination in the Sahyadri region known for its untouched beauty, dense greenery, and seasonal heavy water flow during monsoon. It is a perfect offbeat group travel destination from Pune for nature lovers, photography groups, and adventure seekers looking for peaceful trekking experiences away from city crowds."
},
{
"title": "Torna Fort",
"description":
"Torna Fort, also known as Prachandagad, is one of the oldest and highest forts in Pune district famous for its historical significance in the Maratha Empire. It offers challenging trekking routes, breathtaking valley views, and ancient fort ruins. It is highly popular among adventure groups and trekking enthusiasts from Pune."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury township near Lonavala known for scenic landscapes, private roads, lakes, and premium resorts. It is a popular destination for corporate group outings, luxury tours, and weekend relaxation trips from Pune."
},
{
"title": "Ghangad Fort",
"description":
"Ghangad Fort is a small but scenic fort near Tamhini Ghat known for easy trekking routes, panoramic valley views, and historical ruins. It is suitable for beginner trekking groups and nature trips from Pune."
},
{
"title": "Tikona Fort",
"description":
"Tikona Fort is a pyramid-shaped hill fort known for its short trek, ancient caves, and panoramic views of Pawna Lake. It is a popular weekend trekking destination for group travelers from Pune."
},
{
"title": "Andharban Jungle Trek",
"description":
"Andharban Jungle Trek is a dense forest trail known for deep jungle walks, waterfalls, misty valleys, and thrilling monsoon trekking experiences. It is widely chosen by adventure groups and trekking clubs from Pune."
},
{
"title": "Rajmachi Night Trek",
"description":
"Rajmachi Night Trek is a famous trekking experience involving night hiking through forest trails leading to historic forts and sunrise viewpoints. It is highly popular among adventure groups, college trips, and trekking enthusiasts from Pune."
}
],



services: [
  {
    name: "14 Seater Tempo Traveller Aundh",
    description: "14 seater Tempo Traveller Aundh service provides comfortable transportation for airport transfers, corporate travel, sightseeing tours, family outings, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Aundh Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Aundh",
    description: "17 seater Tempo Traveller Aundh service offers spacious transportation for employee outings, pilgrimage journeys, educational tours, family vacations, and tourist travel. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Aundh Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Aundh",
    description: "20 seater Tempo Traveller Aundh service provides reliable transportation for corporate events, airport transfers, wedding functions, office outings, and group travel requirements. Spacious interiors and luggage capacity ensure comfortable journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Aundh Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Aundh",
    description: "Tempo Traveller for corporate Aundh service offers professional transportation for business meetings, office outings, conferences, employee travel, and executive journeys. Spacious seating and smooth travel performance ensure comfortable experiences suitable for office teams and corporate passengers. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from offices, hotels, commercial locations, and business hubs across Aundh Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for IT Companies Aundh",
    description: "Tempo Traveller for IT companies Aundh service provides dependable transportation for employee movement, office shuttle services, airport transfers, company outings, and business travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for IT professionals and executive teams. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from offices, homes, hotels, and IT locations across Aundh Pune. Flexible booking options allow convenient IT company traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Aundh",
    description: "Tempo Traveller for wedding Aundh service offers stylish transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Aundh Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Aundh",
    description: "Tempo Traveller for airport pickup Aundh service provides reliable transportation for tourists, business travelers, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and Pune Airport across Aundh Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Aundh to Shirdi Tempo Traveller",
    description: "Aundh to Shirdi Tempo Traveller service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Aundh Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, and residential areas across Aundh Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Aundh to Mumbai Tempo Traveller",
    description: "Aundh to Mumbai Tempo Traveller service offers reliable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Aundh Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Aundh to Lonavala Tempo Traveller",
    description: "Aundh to Lonavala Tempo Traveller service provides comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Aundh Pune. Spacious interiors and smooth expressway travel ensure pleasant journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Aundh Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "Aundh to Mahabaleshwar Tempo Traveller",
    description: "Aundh to Mahabaleshwar Tempo Traveller service offers dependable transportation for hill station vacations, sightseeing tours, family outings, and tourist travel from Aundh Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for family and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Aundh Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Aundh to Goa Tempo Traveller",
    description: "Aundh to Goa Tempo Traveller service provides premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Aundh Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, and residential locations across Aundh Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Aundh",
    description: "Luxury Tempo Traveller Aundh service offers premium transportation for weddings, corporate events, airport transfers, sightseeing tours, and family vacations. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Aundh Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Aundh",
    description: "AC Tempo Traveller Aundh service provides premium air-conditioned transportation for business travel, educational tours, airport transfers, office outings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Aundh Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Non AC Tempo Traveller Aundh",
    description: "Non AC Tempo Traveller Aundh service offers affordable transportation for educational tours, local sightseeing, office travel, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Aundh Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "Affordable Tempo Traveller Aundh",
    description: "Affordable Tempo Traveller Aundh service provides economical transportation for family outings, school trips, office travel, sightseeing tours, weddings, and local or outstation journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Aundh Pune. Flexible booking options allow convenient affordable traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Baner Nearby",
    description: "Tempo Traveller hire Baner nearby service offers dependable transportation for airport transfers, office outings, sightseeing tours, family functions, and outstation travel. Spacious seating and smooth travel performance ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Baner Pune. Flexible booking options allow convenient traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Aundh", "17 Seater Tempo Traveller Aundh"],
  ["20 Seater Tempo Traveller Aundh", "Tempo Traveller for Corporate Aundh"],
  ["Tempo Traveller for IT Companies Aundh", "Tempo Traveller for Wedding Aundh"],
  ["Tempo Traveller for Airport Pickup Aundh", "Aundh to Shirdi Tempo Traveller"],
  ["Aundh to Mumbai Tempo Traveller", "Aundh to Lonavala Tempo Traveller"],
  ["Aundh to Mahabaleshwar Tempo Traveller", "Aundh to Goa Tempo Traveller"],
  ["Luxury Tempo Traveller Aundh", "AC Tempo Traveller Aundh"],
  ["Non AC Tempo Traveller Aundh", "Affordable Tempo Traveller Aundh"],
  ["Tempo Traveller Hire Baner Nearby", "14 Seater Tempo Traveller Aundh"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Aundh Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller rental service in Aundh Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate trips, family tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller on rent in Aundh Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller rental service in Aundh Pune operates 24 hours for airport transfers, employee transportation, weddings, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Aundh & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Aundh, Baner, Pashan, Balewadi, Wakad, Shivajinagar, University Road, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller on rent in Aundh Pune?", answer: "Tempo Traveller rental service in Aundh Pune provides comfortable group transportation for corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Aundh?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service in Aundh Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Aundh?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Aundh Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Aundh?", answer: "Yes, Aaradhya Travels provides Tempo Traveller rental service for corporate meetings, office outings, conferences, and employee transportation in Aundh." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Aundh Pune?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Avinash Kulkarni",
    feedback:
      "A group trip from Aundh Pune became very easy with Aaradhya Travels providing a Tempo Traveller. The vehicle was clean, comfortable, and the journey felt well managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Joshi",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller on rent in Aundh Pune for our family outing, and the experience was very smooth. Everyone could travel together comfortably, and the service was reliable.",
    rating: 5
  }
];










  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Aundh Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-on-rent-in-aundh.jpg",
  "description": "Book Tempo Traveller on rent in Aundh Pune with Aaradhya Travels for corporate travel, IT companies, weddings, airport transfers, family trips, and outstation journeys. Available in 14, 17, and 20 seater tempo travellers for Shirdi, Mumbai, Lonavala, Mahabaleshwar, and Goa routes.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4621"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-on-rent-in-aundh"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller on Rent in Aundh Pune | Corporate & IT Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller on rent in Aundh Pune with Aaradhya Travels. Affordable 14, 17, and 20 seater tempo traveller available for IT companies, corporate travel, weddings, airport pickup, family trips, and outstation tours to Shirdi, Mumbai, Lonavala, Mahabaleshwar, and Goa."
  />

  <meta
    name="keywords"
    content="14 seater tempo traveller Aundh, 17 seater tempo traveller Aundh, 20 seater tempo traveller Aundh, Tempo traveller for corporate Aundh, Tempo traveller for IT companies Aundh, Tempo traveller for wedding Aundh, Tempo traveller for airport pickup Aundh, Aundh to Shirdi tempo traveller, Aundh to Mumbai tempo traveller, Aundh to Lonavala tempo traveller"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinaundhpune;